var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.0972C22.7614 25.0972 25 22.8586 25 20.0972C25 17.3357 22.7614 15.0972 20 15.0972C17.2386 15.0972 15 17.3357 15 20.0972C15 22.8586 17.2386 25.0972 20 25.0972Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 21.5639V18.6306C3.33325 16.8972 4.74992 15.4639 6.49992 15.4639C9.51659 15.4639 10.7499 13.3306 9.23325 10.7139C8.36659 9.21389 8.88325 7.26389 10.3999 6.39722L13.2833 4.74722C14.5999 3.96389 16.2999 4.43056 17.0833 5.74722L17.2666 6.06389C18.7666 8.68056 21.2333 8.68056 22.7499 6.06389L22.9333 5.74722C23.7166 4.43056 25.4166 3.96389 26.7333 4.74722L29.6166 6.39722C31.1333 7.26389 31.6499 9.21389 30.7833 10.7139C29.2666 13.3306 30.4999 15.4639 33.5166 15.4639C35.2499 15.4639 36.6833 16.8806 36.6833 18.6306V21.5639C36.6833 23.2972 35.2666 24.7306 33.5166 24.7306C30.4999 24.7306 29.2666 26.8639 30.7833 29.4806C31.6499 30.9972 31.1333 32.9306 29.6166 33.7972L26.7333 35.4472C25.4166 36.2306 23.7166 35.7639 22.9333 34.4472L22.7499 34.1306C21.2499 31.5139 18.7833 31.5139 17.2666 34.1306L17.0833 34.4472C16.2999 35.7639 14.5999 36.2306 13.2833 35.4472L10.3999 33.7972C8.88325 32.9306 8.36659 30.9806 9.23325 29.4806C10.7499 26.8639 9.51659 24.7306 6.49992 24.7306C4.74992 24.7306 3.33325 23.2972 3.33325 21.5639Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.8f5bb90e9e511f8064d510c78af7395a.svg";
export { ForwardRef as ReactComponent };